import { TaskExecution, WidgetTypeEnum } from "shared/api";
import dayjs from "dayjs";

export const enum MyTaskExecutionsWidgetEnum {
  TASK_EXECUTION_DATE_TIME = "taskExecutionDateTime",
  TASK_EXECUTION_TASK = "taskExecutionTask",
  TASK_EXECUTION_STATUS = "taskExecutionStatus",
  TASK_EXECUTION_USER = "taskExecutionUser",
}

export const myTaskExecutionsColumnsValues = [
  { value: "taskExecutionDateTime", label: "taskExecutionDateTime" },
  { value: "taskExecutionTask", label: "taskExecutionTask" },
  { value: "taskExecutionStatus", label: "taskExecutionStatus" },
  { value: "taskExecutionUser", label: "taskExecutionUser" },
];

export const adaptMyTaskExecutionsData = (
  tasksData: TaskExecution[] | undefined
) => {
  if (!tasksData || !Array.isArray(tasksData)) {
    return [];
  }

  return tasksData.map((task) => ({
    type: WidgetTypeEnum.MY_TASK_EXECUTIONS,

    taskExecutionDateTime: task?.timestamp_expected
      ? dayjs(task.timestamp_expected).format("YYYY-MM-DD HH:mm:ss")
      : "No Data",

    taskExecutionTask: task?.task?.name ?? "No Data",

    taskExecutionStatus: task?.status ?? "No Data",

    taskExecutionUser:
      typeof task.user === "object" && task.user?.username
        ? task.user.username
        : "No Data",
  }));
};
